import { Group } from '@mantine/core';
import { IconWorldPlus, IconWorldX } from '@tabler/icons-react';
import Button from 'components/Button';
import FormInputGroup from 'components/forms/FormInputGroup';
import { OrganizationMultiSelect } from 'components/selects/OrganizationSelect';
import P1Regular from 'components/typography/P1Regular';
import { ReactNode } from 'react';

interface OrganizationStructureScopeProps {
  allOrganizations: boolean;
  selectedOrganizations: string[];
  onAllOrganizationsChange: (value: boolean) => void;
  onSelectedOrganizationsChange: (value: string[]) => void;
  allOrganizationsText: string;
  error?: ReactNode;
  name?: string;
  showDiscarded?: boolean;
}

/** Shared organization structure scope used by evidence and HR configuration forms. */
export default function OrganizationStructureScope({
  allOrganizations,
  selectedOrganizations,
  onAllOrganizationsChange,
  onSelectedOrganizationsChange,
  allOrganizationsText,
  error,
  name = 'selectedOrganizations',
  showDiscarded = false,
}: OrganizationStructureScopeProps) {
  return (
    <FormInputGroup groupTitle="Vymedzenie štruktúry">
      {allOrganizations ? (
        <Group spacing={8} align="center">
          <P1Regular>{allOrganizationsText}</P1Regular>
          <Button
            type="button"
            variant="subtle"
            leftIcon={<IconWorldX />}
            onClick={() => onAllOrganizationsChange(false)}
          >
            Zrušiť
          </Button>
        </Group>
      ) : (
        <>
          <OrganizationMultiSelect
            size="lg"
            name={name}
            label="Vyberte organizácie"
            placeholder="Vyberte organizácie"
            withAsterisk
            showDiscarded={showDiscarded}
            value={selectedOrganizations}
            error={error}
            onChange={onSelectedOrganizationsChange}
          />
          <Group spacing={8} mt={-12}>
            <P1Regular>Alebo</P1Regular>
            <Button
              type="button"
              variant="subtle"
              leftIcon={<IconWorldPlus />}
              onClick={() => {
                onSelectedOrganizationsChange([]);
                onAllOrganizationsChange(true);
              }}
            >
              Použiť pre všetky organizácie
            </Button>
          </Group>
        </>
      )}
    </FormInputGroup>
  );
}
